module.exports = __webpack_public_path__ + "favicon-32x32.717b7282.png";